<template>
	<div class="repair headFixed">
		<HeadNav title="在线报修"></HeadNav>

		<ul class="nav clear container">
			<!-- <li :class="this.lucky==0?'active':''" @click="changelucky(0)">个人信息</li> -->
			<li :class="this.lucky == 1 ? 'active' : ''" @click="changelucky(1)">服务需求</li>
		</ul>
		<div class="lucky-content">
			<div class="luckyItem" :class="this.lucky == 0 ? '' : 'hide'">
				<div class="item">
					<label>姓&nbsp;&nbsp;&nbsp;名:</label>
					<div><input type="text" name="" /></div>
				</div>
				<div class="item">
					<label>电&nbsp;&nbsp;&nbsp;话:</label>
					<div><input type="number" name="" /></div>
				</div>
				<div class="item">
					<label>省&nbsp;&nbsp;&nbsp;份:</label>
					<div><input type="text" name="" /></div>
				</div>
				<div class="item">
					<label>城&nbsp;&nbsp;&nbsp;市:</label>
					<div><input type="text" name="" /></div>
				</div>
				<div class="item">
					<label>地&nbsp;&nbsp;&nbsp;区:</label>
					<div><input type="text" name="" /></div>
				</div>
				<div class="item">
					<label>详&nbsp;&nbsp;&nbsp;细:</label>
					<div><input type="text" name="" /></div>
				</div>
			</div>
			<div class="luckyItem luckyItem2" :class="this.lucky == 1 ? '' : 'hide'">
				<div class="item">
					<label>设备名称:</label>
					<div><input type="text" name="" v-model="name" readonly @click="showPopup" /></div>
				</div>
				<div class="item">
					<label>型&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号:</label>
					<div><input type="text" name="" v-model="number" readonly @click="showPopup" /></div>
				</div>
				<div class="item">
					<label>服务日期:</label>
					<div @click="openPicker"><input type="text" readonly name="" v-model="new Date(date).format('yyyy-MM-dd')" /></div>
				</div>
				<div class="item border-none">
					<label>故障描述:</label>
					<div><textarea name="" v-model="faultContent"></textarea></div>
				</div>
			</div>
		</div>

		<span class="repairPicker"><mt-datetime-picker ref="picker" type="date" v-model="pickerValue" :startDate="startDate" @confirm="handleConfirm"></mt-datetime-picker></span>

		<div class="container submitBtn">
			<div v-show="this.lucky == 0"><mt-button size="large" type="primary" @click="handleNext(1)" class="">下一步</mt-button></div>
			<div v-show="this.lucky == 1" class="btn-group">
				<mt-button size="large" type="primary" @click="submitRequire()" class="">提交</mt-button>
				<mt-button size="large" type="primary" @click="handelReset()" class="btn-liner-orange">重置</mt-button>
			</div>
		</div>

		<mt-popup v-model="popupVisible" class="pubPopup" modal="false" position="bottom">
			<mt-picker :slots="myAddressSlots" ref="areaPicker" class="picker" valueKey="eqMix" :visible-item-count="5" @change="onMyAddressChange"></mt-picker>

			<div class="picker-btn-wrap clear">
				<div class="picker-cancel" @click="addressChooseCancel">取消</div>
				<div class="picker-mid">设备名称(型号)</div>
				<div class="picker-sure" @click="confirmChoose">确定</div>
			</div>
		</mt-popup>
	</div>
</template>
<script>
import { Toast, DatetimePicker, Popup, Picker } from 'mint-ui';
import HeadNav from '../headNav/headNav';

export default {
	name: 'repair',
	data() {
		return {
			lucky: 1,
			name: null,
			number: null,
      iotDeviceId:null,
			date: new Date(),
			faultContent: null,
			pickerValue: new Date(),
			startDate: new Date(),
			myAddressSlots: [
				{
					flex: 1,
					defaultIndex: 0,
					values: [],
					className: 'slot1',
					textAlign: 'center'
				}
			],
			popupVisible: false,
			currentEq: null
		};
	},
	mounted() {
		this.eqList();
	},
	components: {
		HeadNav: HeadNav,
		DatetimePicker
	},
	methods: {
		changelucky(i) {
			this.lucky = i;
		},
		handleNext(i) {
			this.lucky = i;
		},

		handelReset() {
			this.name = null;
			this.number = null;
			this.faultContent = null;
      this.iotDeviceId = null;
			this.pickerValue = new Date();
			this.date = new Date();
		},

		openPicker() {
			this.$refs.picker.open();
		},

		submitRequire() {
			let params = {};
			params.name = this.name;
			params.number = this.number;
      params.iotDeviceId = this.iotDeviceId;
			params.serviceTime = new Date(this.date).getTime();
			params.faultContent = this.faultContent;
			if (!(this.name || this.name == 0)) {
				Toast('请填写设备名称');
				return false;
			}
			if (!(this.number || this.number == 0)) {
				Toast('请填写设备编码');
				return false;
			}
			if (!(this.faultContent || this.faultContent == 0)) {
				Toast('请填写设备描述');
				return false;
			}
			this.Api.equipmentRepairAdd(params, msg => {
				if (msg.code === 200) {
					Toast('报修成功');
					this.handelReset();
					this.$router.push({ name: 'Equipment' });
				} else {
					Toast('报修失败，请稍后重试');
				}
			});
		},

		handleConfirm(val) {
			this.date = val;
		},

		eqList(pageNo) {
			this.Api.eqListAll(msg => {
				if (msg.code === 200) {
					let list = msg.data;
					if(list!=null){
					let arr = [];
					for (let i = 0; i < list.length; i++) {
						let obj = {};
            obj.iotDeviceId = list[i].iotDeviceId;
						obj.name = list[i].name;
						obj.number = list[i].number;
						obj.eqMix = list[i].name + '(' + list[i].number + ')';
						arr.push(obj);
					}
					this.myAddressSlots[0].values = arr;

					}
				}
			});
		},
		onMyAddressChange(picker, values) {
			this.currentEq = values[0];
		},
		confirmChoose() {
			this.name = this.currentEq.name;
      this.iotDeviceId = this.currentEq.iotDeviceId
			this.number = this.currentEq.number;
			this.addressChooseCancel();
		},
		addressChooseCancel() {
			this.popupVisible = false;
		},
		showPopup() {
			this.popupVisible = true;
		}
	}
};
</script>

<style scoped>
@import url('../../assets/list.css');
@import url('./repair.css');

.repairPicker .mint-popup {
	border-radius: 0;
	width: 100%;
}

.picker-btn-wrap {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	line-height: 60px;
	font-size: 18px;
	background: #ffffff;
	z-index: 1;
	border-bottom: 1px dotted #aaa;
}

.picker-btn-wrap > div {
	display: inline-block;
	padding: 0 15px;
}

.picker-sure {
	float: right;
}

.picker-mid {
	position: absolute;
	top: 0;
	left: 50%;
	margin-left: -75px;
	color: #3c7cff;
}

.pubPopup {
	padding: 50px 0px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/repair/repair.vue